import React, { forwardRef, useState, useEffect } from 'react'
import { Cascader } from '@ow/comps'
import { useDitto } from '@ow/ditto-core'
import { listToTree } from '@ow/utils'

const Render = function ({ opts = {}, onChange, value, style }, ref) {
  const { remote = {} } = opts
  const { onFetchRemoteData } = useDitto()
  const [options, setOptions] = useState([])

  useEffect(() => {
    if (onFetchRemoteData && remote && remote.api) {
      if (remote && remote.api) {
        const extend = onFetchRemoteData('extend')

        extend[remote.api](remote.url, remote.opts).then((res) => {
          if (res) {
            setOptions(
              listToTree(
                (res || []).map((option) => {
                  return { ...option, label: option.title }
                })
              )
            )
          }
        })
      }
    }
  }, [])

  return (
    <div className="relative flex flex-row items-center w-full" ref={ref}>
      {opts.render === 'cascader' && (
        <Cascader
          tree={options}
          inputStyle={{
            height: '34px',
            width: '100%',
            ...style,
          }}
          placeholder={opts.hint || `请选择${opts.title}`}
          inputClassName="right-input"
          fieldNames={{
            label: 'title',
            value: 'title',
            children: 'children',
          }}
          allowClear={false}
          onChange={(selectedKeys) => {
            onChange(selectedKeys)
          }}
          value={value || undefined}
          multiple
          notFoundContent="暂无数据"
        />
      )}
    </div>
  )
}

export default forwardRef(Render)
